export default "__VITE_ASSET__DfnzyTK6__"